import React from 'react';
import CustomForm from './custom-form';
import LocationForm from './location-form';
const $ = window.$;

class FormTabs extends React.Component {
  componentDidMount() {
    $(document).ready(() => {
      $('#alert-tabs').tabs();
    });
  }
  render() {
    return (
      <div className={this.props.className}>
      <h5>Message & Call</h5>
        <div className="col m12 s12 center">
          <ul id={'alert-tabs'} className="tabs tabs-fixed-width ">
            <li className="tab col s3"><a href="#tab1" className="tab-text">Location Based</a></li>
            <li className="tab col s3"><a href="#tab2" className="tab-text">Custom</a></li>
          </ul>
        </div>
        <div id="tab1" className="col s12">
          <LocationForm className="center form-card"/>
        </div>
        <div id="tab2" className="col s12">
          <CustomForm className="center form-card"/>
        </div>

      </div>
    )
  }
}

export default FormTabs;



// WEBPACK FOOTER //
// ./src/components/alert/formTabs.js